{
  "nickname": "Biệt danh",
  "userId": "Mã người dùng",
  "userIdValue": "UID{{id}}",
  "connectedAppsDate": "{{label}}: {{date}}",
  "kyc": "Xác minh danh tính",
  "loginPassword": "Mật khẩu đăng nhập",
  "txPassword": "Mật khẩu giao dịch",
  "paymentMethod": "Phương thức nhận hoặc thanh toán",
  "connectedApps": "Ứng dụng đã kết nối",
  "connectedAppsNotConnected": "Chưa kết nối",
  "connectedAppsEmpty": "Chưa có ứng dụng nào được kết nối",
  "connectedAppsConnectedAt": "Thời gian kết nối",
  "connectedAppsLastUsedAt": "Sử dụng gần đây",
  "connectedAppsDisconnect": "Ngắt kết nối",
  "connectedAppsDisconnectTitle": "Ngắt kết nối ứng dụng",
  "connectedAppsDisconnectDesc": "Sau khi ngắt kết nối, ứng dụng này không thể tiếp tục dùng {{token}} để thanh toán.",
  "connectedAppsDisconnectSuccess": "Đã ngắt kết nối",
  "connectedAppsDisconnectFailed": "Không thể ngắt kết nối",
  "connectAppTitle": "Kết nối ứng dụng",
  "connectAppName": "Tên ứng dụng",
  "connectAppOrder": "Mã đơn hàng ứng dụng",
  "connectAppExpiresAt": "Thời hạn",
  "connectAppConfirmDesc": "Sau khi xác nhận, ứng dụng này có thể dùng {{token}} để thanh toán theo ủy quyền của bạn.",
  "connectAppConfirm": "Xác nhận kết nối",
  "connectAppApproveSuccess": "Kết nối thành công",
  "connectAppApproveFailed": "Kết nối thất bại",
  "notification": "Cài đặt",
  "contactCS": "Liên hệ hỗ trợ",
  "logoutTitle": "Xác nhận đăng xuất",
  "logoutDesc": "Bạn có chắc muốn đăng xuất không?",
  "logout": "Đăng xuất",
  "cancel": "Hủy",
  "version": "Phiên bản",
  "phone": "Số điện thoại",
  "notVerified": "Chưa xác minh",
  "kycRejected": "Không đạt xác minh",
  "kycReviewing": "Đang xét duyệt",
  "kycVerified": "Đã xác minh",
  "notAdded": "Chưa thêm",
  "set": "Đã thiết lập",
  "notSet": "Chưa thiết lập",
  "nicknameNotSet": "Chưa đặt biệt danh",
  "copied": "Đã sao chép",
  "upgradeGuide": "Hướng dẫn nâng cấp",
  "upgradeHint": "Đạt điều kiện để nâng cấp và nhận thêm ưu đãi!"
}
